import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetJobSeekerProfileById = (): any => {
  const { data, isLoading, send } = useRequest({
    /* url: `/api/v1/jobPosts/${jobPostId}`, */
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getJobSeekerProfileById = (userId, jobPostId = null) => {
    if (jobPostId) {
      send({}, `api/v1/profile/jobSeeker/${userId}?jobPostId=${jobPostId}`).then();
    } else {
      send({}, `api/v1/profile/jobSeeker/${userId}`).then();
    }
  };

  return {
    isLoading,
    getJobSeekerProfileById,
    data,
  };
};
